import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import EmailLogsService from '@/services/SettingsServices/EmailLogsService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: [],
    totalItems: 0,
    emailContent: null,
    xlsxUrl: null,
    error: null,
    loading: false,
};

export const getEmailLogs = createAsyncThunk(
    'emailLogs/getEmailLogs',
    async (data, { rejectWithValue }) => {
        try {
            const response = await EmailLogsService.getEmailLogs(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const getEmailContent = createAsyncThunk(
    'emailLogs/getEmailContent',
    async (filters, { rejectWithValue }) => {
        try {
            const response = await EmailLogsService.getEmailContent(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

export const downloadData = createAsyncThunk(
    'emailLogs/downloadData',
    async (data, { rejectWithValue }) => {
        try {
            const response = await EmailLogsService.downloadData(data);
            const { file_url: xlsxUrl } = response.data;
            return xlsxUrl;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const emailLogsSlice = createSlice({
    name: 'emailLogs',
    initialState: model,
    reducers: {
        resetEmailContent: (state) => {
            state.emailContent = null;
        },
        resetDownloadState: (state) => {
            state.xlsxUrl = null;
        },
    },
    extraReducers: (builder) => {
        // get email logs
        builder.addCase(getEmailLogs.pending, (state) => {
            state.loading = true;
        }).addCase(getEmailLogs.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.email_logs;
            state.totalItems = action.payload.total;
        }).addCase(getEmailLogs.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // get email content
        builder.addCase(getEmailContent.pending, (state) => {
            state.loading = true;
        }).addCase(getEmailContent.fulfilled, (state, action) => {
            state.loading = false;
            state.emailContent = action.payload;
        }).addCase(getEmailContent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // download data
        builder.addCase(downloadData.pending, (state) => {
            state.loading = true;
        }).addCase(downloadData.fulfilled, (state, action) => {
            state.loading = false;
            state.xlsxUrl = action.payload;
        }).addCase(downloadData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { resetEmailContent, resetDownloadState } = emailLogsSlice.actions;

export default emailLogsSlice.reducer;
